import React from 'react';

export default {
  width: 16,
  height: 16,
  fill: 'none',
  content: <path d="M4 13V4L13 8.5L4 13Z" stroke="#202020" strokeWidth="1" fill="none" />
};
